/**
 * Google Translate (Chrome sayfa çevirisi) ve benzeri araçlar React'in çizdiği
 * metin düğümlerini kendi <font> etiketlerine sarar. React bir sonraki render'da
 * removeChild/insertBefore çağırınca DOM "NotFoundError: not a child of this node"
 * fırlatır ve tüm uygulama error boundary'ye düşer (React issue #11538).
 *
 * Bu guard yalnızca zaten exception fırlatacak çağrıları yakalar; normal çağrılar
 * birebir orijinal davranışla çalışır. Render'dan ÖNCE kurulmalıdır (main.tsx).
 */
export function installDomMutationGuard(): void {
  if (typeof Node !== 'function' || !Node.prototype) return

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn(
        '[dom-guard] removeChild atlandı: düğüm bu parent\'ın çocuğu değil (sayfa çevirisi etkisi olabilir)',
      )
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn(
        '[dom-guard] insertBefore sona eklemeye düştü: referans düğüm bu parent\'ın çocuğu değil (sayfa çevirisi etkisi olabilir)',
      )
      return this.appendChild(newNode)
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
